import { apiClient } from '@/lib/api'

/**
 * Dictionaries API - Estates (Property types, Rooms, Repairs, etc.)
 */

// Property Types (Type Facility)
export const propertyTypesApi = {
  getAll: (params = {}) => apiClient.get('/v1/estates/property-types/', { params }),
}

// Rooms
export const roomsApi = {
  getAll: (params = {}) => apiClient.get('/v1/estates/rooms/', { params }),
}

// Repairs
export const repairsApi = {
  getAll: (params = {}) => apiClient.get('/v1/estates/repairs/', { params }),
}

// Conditions
export const conditionsApi = {
  getAll: (params = {}) => apiClient.get('/v1/estates/conditions/', { params }),
}

// Buildings
export const buildingsApi = {
  getAll: (params = {}) => apiClient.get('/v1/estates/buildings/', { params }),
}

// Actualities
export const actualitiesApi = {
  getAll: (params = {}) => apiClient.get('/v1/estates/actualities/', { params }),
}

// Live Complexes
export const liveComplexesApi = {
  getAutocomplete: (params = {}) => apiClient.get('/v1/estates/live-complexes/autocomplete/', { params }),
}
